// Context to store id of selected item

import {createContext} from 'react';

export const ItemsListContext = createContext({
    selectedItemId: '',
});
